<template>
  <div
    class="absolute top-1/2 z-10 -mt-7 !flex -translate-y-1/2 cursor-pointer !items-center !justify-center before:!content-none focus:ring-2"
    :class="{
      '!left-0 pl-2': side === 'left' && !outside,
      '!right-0 pr-2': side === 'right' && !outside,
      '!right-full': side === 'left' && outside,
      '!left-full': side === 'right' && outside,
      '!h-10 !w-8 lg:!h-16 lg:!w-12': !small,
      '!h-10 !w-8': small,
    }"
    role="button"
    :aria-label="ariaLabel"
  >
    <IconArrowLeft
      class="text-black"
      :class="{
        'rotate-180': side !== 'left',
      }"
    />
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  side: {
    type: String as PropType<'left' | 'right'>,
    required: true,
    validator: (val: string) => ['left', 'right'].includes(val),
  },
  small: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
  outside: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
})

const { t } = useI18n()
const ariaLabel = computed(() => {
  return props.side === 'left'
    ? t('navigation.pagination.previous')
    : t('navigation.pagination.next')
})
</script>
